import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Flex,
  useDisclosure,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from '@chakra-ui/react'
import { format } from 'date-fns'

export const HistoricoGeral = ({ historicoGeral, itensPorLayout }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()
  return (
    <Flex alignItems="center" justifyContent="center">
      <Button _focus={{ outline: 'none' }} size="xs" colorScheme="blue" variant="link" onClick={onOpen} isDisabled={historicoGeral.length === 0}>
        {itensPorLayout}
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Histórico Geral</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" gap={2}>
              <TableContainer>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Data Início</Th>
                      <Th>Usuário Início</Th>
                      <Th>Data Término</Th>
                      <Th>Usuário Término</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {historicoGeral.map((item, index) => (
                      <Tr key={index}>
                        <Td>{item.data_inicio ? format(new Date(item.data_inicio), 'dd/MM/yyyy HH:mm') : ''}</Td>
                        <Td>{item.usuario_inicio}</Td>
                        <Td>{item.data_finalizacao ? format(new Date(item.data_finalizacao), 'dd/MM/yyyy HH:mm') : ''}</Td>
                        <Td>{item.usuario_finalizacao}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  )
}
